(function () {
  var $ = function (s, ctx) { return (ctx || document).querySelector(s); };
  var $$ = function (s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); };

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------------- Collection filter + search ---------------- */
  var grid = document.getElementById('products');
  if (grid) {
            var filter = 'All';
            var requestedFilter = new URLSearchParams(window.location.search).get('collection');
            if (requestedFilter) filter = requestedFilter;
    var cards = $$('[data-product-card]', grid);
    var search = document.getElementById('search');
    var resultCount = document.getElementById('result-count');
    var empty = document.getElementById('empty');

    var applyFilter = function () {
      var q = ((search && search.value) || '').trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (card) {
              var categoryNeedle = filter === 'Tees' ? 'tee' : filter === 'Hoodies' ? 'hoodie' : filter === 'Long Sleeves' ? 'long sleeve' : filter.toLowerCase();
      var matchesCategory = filter === 'All' || (card.dataset.search || '').indexOf(categoryNeedle) !== -1;
        var matchesSearch = !q || (card.dataset.search || '').indexOf(q) !== -1;
        var visible = matchesCategory && matchesSearch;
        card.hidden = !visible;
        if (visible) shown++;
      });
      if (resultCount) resultCount.textContent = shown === 1 ? '1 PIECE' : shown + ' PIECES';
      if (empty) empty.hidden = shown > 0;
      $$('[data-filter]').forEach(function (b) {
        var active = b.dataset.filter === filter;
        b.classList.toggle('active', active);
        b.setAttribute('aria-pressed', String(active));
      });
    };

    document.addEventListener('click', function (e) {
      var f = e.target.closest('[data-filter]');
      if (f) { filter = f.dataset.filter; applyFilter(); }
      var cat = e.target.closest('[data-category]');
      if (cat && cat.dataset.category) {
        e.preventDefault();
        filter = cat.dataset.category;
        if (search) search.value = '';
        applyFilter();
        var collectionSection = document.getElementById('collection');
        if (collectionSection) collectionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var categoryUrl = new URL(window.location.href);
        categoryUrl.searchParams.set('collection', filter);
        history.replaceState({}, '', categoryUrl.pathname + categoryUrl.search + '#collection');
      }
    });
    if (search) search.addEventListener('input', applyFilter);
    var searchClear = document.getElementById('search-clear');
    if (searchClear) searchClear.addEventListener('click', function () {
      if (search) search.value = '';
      filter = 'All';
      applyFilter();
    });
    applyFilter();
  }

  var searchToggle = document.getElementById('search-toggle');
  var searchArea = document.getElementById('search-area');
  if (searchToggle && searchArea) {
    searchToggle.addEventListener('click', function () {
      searchArea.hidden = false;
      var coll = document.getElementById('collection');
      if (coll) coll.scrollIntoView();
      var input = document.getElementById('search');
      if (input) input.focus({ preventScroll: true });
    });
  }

  var BAG_PRODUCT_FRONT_INDEX = {
    'afterhours-hoodie': { 'Gray': 2, 'Black': 6 },
    'autograph-long-sleeve': { 'Ash Heather Gray': 27, 'Coral Pink': 29, 'Dark Brown Coffee': 31, 'Sage Olive Green': 33, 'Navy': 35, 'White': 37, 'Forest Green': 39, 'Pale Yellow': 41, 'Sand Beige': 43, 'Black': 45, 'Cream Ivory': 47, 'Stone Taupe': 49, 'Charcoal': 51 },
    'northstar-tee': { 'Khaki Tan': 15, 'White': 2, 'Sand Cream': 13, 'Black': 5, 'Dark Gray': 7 },
    'northstar-graphic-tee': { 'Khaki Tan': 15, 'White': 2, 'Sand Cream': 13, 'Black': 5, 'Dark Gray': 7 },
    'origin-tee': { 'Gray Green': 17, 'White': 2, 'Sand Beige': 4, 'Black': 6, 'Charcoal': 8 },
    'wayfinder-denim': { 'Light Wash Blue': 3 }
  };
  var bagProductDataCache = {};
  var bagImageUrlCache = {};

  function bagItemColor(item) {
    var options = item.options_with_values || [];
    for (var i = 0; i < options.length; i++) {
      if ((options[i].name || '').toLowerCase() === 'color') return options[i].value;
    }
    var choices = BAG_PRODUCT_FRONT_INDEX[item.handle] || {};
    var title = item.variant_title || '';
    var colors = Object.keys(choices);
    for (var j = 0; j < colors.length; j++) {
      if (title.indexOf(colors[j]) !== -1) return colors[j];
    }
    return '';
  }

  function sizedBagImageUrl(url) {
    var source = String(url || '');
    if (!source) return '';
    return source + (source.indexOf('?') === -1 ? '?' : '&') + 'width=360';
  }

  function bagProductData(handle) {
    if (!bagProductDataCache[handle]) {
      bagProductDataCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('product-image-request-failed');
        return response.json();
      });
    }
    return bagProductDataCache[handle];
  }

  function resolveBagProductImage(item) {
    var choices = BAG_PRODUCT_FRONT_INDEX[item.handle];
    var color = bagItemColor(item);
    var index = choices && choices[color];
    if (typeof index !== 'number') return Promise.resolve(sizedBagImageUrl(item.image));
    var cacheKey = item.handle + '|' + color;
    if (!bagImageUrlCache[cacheKey]) {
      bagImageUrlCache[cacheKey] = bagProductData(item.handle).then(function (product) {
        var source = product.images && product.images[index];
        if (!source) throw new Error('product-image-not-found');
        return sizedBagImageUrl(source);
      });
    }
    return bagImageUrlCache[cacheKey];
  }

  function loadBagProductImage(item, img) {
    img.className = 'bag-thumb';
    if (item.handle === 'autograph-long-sleeve' || item.handle === 'afterhours-hoodie') img.classList.add('is-matte');
    img.decoding = 'async';
    img.loading = 'eager';
    img.dataset.itemKey = item.key;
    img.removeAttribute('src');
    img.classList.remove('is-ready', 'is-fallback');

    function reveal(url, fallback) {
      if (!url || img.dataset.itemKey !== item.key) return;
      var preloader = new Image();
      preloader.onload = function () {
        if (img.dataset.itemKey !== item.key) return;
        img.src = url;
        img.alt = item.product_title;
        img.classList.toggle('is-fallback', Boolean(fallback));
        img.classList.add('is-ready');
      };
      preloader.onerror = function () {
        if (!fallback && item.image) reveal(sizedBagImageUrl(item.image), true);
      };
      preloader.src = url;
    }

    resolveBagProductImage(item)
      .then(function (url) { reveal(url, false); })
      .catch(function () {
        if (item.image) reveal(sizedBagImageUrl(item.image), true);
      });
  }

  function customerVariantTitle(item) {
    var visible = (item.options_with_values || []).filter(function (option) {
      var name = (option.name || '').toLowerCase();
      var value = String(option.value || '').trim();
      return (name === 'color' || name === 'size') && value && !/^T-Shirts\d+$/i.test(value);
    }).map(function (option) { return option.value; });
    if (visible.length) return visible.join(' / ');
    return String(item.variant_title || '').split(' / ').filter(function (value) {
      return !/^T-Shirts\d+$/i.test(value.trim());
    }).join(' / ');
  }

  /* ---------------- Bag / real Shopify cart ---------------- */
  function renderBagArea(area, emptyNote, cart) {
    while (area.firstChild) area.removeChild(area.firstChild);

    if (!cart.items.length) {
      if (emptyNote) emptyNote.hidden = false;
      return;
    }
    if (emptyNote) emptyNote.hidden = true;

    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'bag-row';

      var img = document.createElement('img');
      img.alt = '';
      loadBagProductImage(item, img);

      var text = document.createElement('div');
      var title = document.createElement('span');
      title.textContent = item.product_title;
      var detail = document.createElement('p');
      detail.textContent = customerVariantTitle(item) + ' · ' + money(item.final_price, cart.currency);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'REMOVE';
      remove.dataset.removeKey = item.key;

      text.appendChild(title);
      text.appendChild(detail);
      row.appendChild(img);
      row.appendChild(text);
      row.appendChild(remove);
      area.appendChild(row);
    });

    var total = document.createElement('p');
    total.className = 'bag-subtotal';
    total.textContent = 'SUBTOTAL · ' + money(cart.total_price, cart.currency);
    area.appendChild(total);
  }

  function renderBag(cart) {
    var count = document.getElementById('bag-count');
    if (count) count.textContent = cart.item_count;

    var areas = Array.prototype.slice.call(document.querySelectorAll('[id="bag-items"]'));
    areas.forEach(function (area) {
      var scope = area.closest('dialog, main, form') || document;
      var emptyNote = scope.querySelector('[id="bag-empty-note"]');
      renderBagArea(area, emptyNote, cart);
    });
  }

  function fetchCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderBag)
      .catch(function () {});
  }

  function addToCart(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-failed');
      return r.json();
    });
  }

  function changeCart(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('visible');
    setTimeout(function () { t.classList.remove('visible'); }, 2200);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#bag-toggle')) {
      var d = document.getElementById('bag-dialog');
      if (d && d.showModal) d.showModal();
      fetchCart();
    }
    if (e.target.closest('[data-close]')) {
      var dlg = e.target.closest('dialog');
      if (dlg) dlg.close();
    }
    var removeBtn = e.target.closest('[data-remove-key]');
    if (removeBtn) {
      changeCart(removeBtn.dataset.removeKey, 0).then(fetchCart);
    }
  });

  $$('dialog').forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target === d) {
        var r = d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
      }
    });
  });

  /* ---------------- Product page ---------------- */
  var COLOR_HEX = {
    white: '#f5f5f3', black: '#141414', apricot: '#f4c9a0', graygreen: '#9aa08c',
    darkgray: '#4a4a4a', navy: '#1b2a4a', blackishgreen: '#1f3327', carbongray: '#3a3a3a',
    brown: '#5b3a29', watermelonred: '#e2637a', graycamel: '#b3a186', yellow: '#f0da6d',
    sandcolor: '#d8c7a5', oatgray: '#cfc9bd', milktea: '#e7d8c4', blue: '#6f93c9', gray: '#8c8c8c',
    charcoal: '#333333', sandbeige: '#ddceac', creamivory: '#f2ecdd', coralpink: '#e28a7b',
    forestgreen: '#1f4023', sageolivegreen: '#a3a887', ashheathergray: '#d3d2ce',
    stonetaupe: '#a89e8c', darkbrowncoffee: '#3d2a1d', paleyellow: '#f2e6a8'
  };
  function swatchHex(name) {
    var key = (name || '').toLowerCase().replace(/[^a-z]/g, '');
    return COLOR_HEX[key] || '#c9c6bf';
  }

  var sizeWrap = document.getElementById('sizes');
  var colorWrap = document.getElementById('colors');
  if (sizeWrap) {
    var form = document.getElementById('product-form');
    var input = document.getElementById('selected-variant-id');
    var addBtn = document.getElementById('add-bag');
    var colorLabel = document.getElementById('selected-color-label');
    var variantDataEl = document.getElementById('variant-data');
    var variants = null;
    if (variantDataEl) {
      try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = null; }
    }

    if (variants && colorWrap) {
      /* ---- Separate color + size selectors ---- */
      var selectedColor = null;
      var selectedSize = null;
      var colorButtons = $$('[data-color]', colorWrap);
      var sizeButtons = $$('[data-size]', sizeWrap);

      colorButtons.forEach(function (b) {
        var dot = b.querySelector('.swatch-dot');
        if (dot) dot.style.background = swatchHex(b.dataset.color);
      });

      function availableSizesFor(color) {
        var set = {};
        variants.forEach(function (v) {
          if (v.color === color && v.available) set[v.size] = true;
        });
        return set;
      }

      function findVariant(color, size) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].color === color && variants[i].size === size) return variants[i];
        }
        return null;
      }

      function updatePrice(variant) {
        if (!variant || typeof variant.price !== 'number') return;
        var priceLabel = money(variant.price, (document.getElementById('product-price') || {}).dataset && document.getElementById('product-price').dataset.currency);
        var productPrice = document.getElementById('product-price');
        var stickyPrice = document.querySelector('.sticky-atc-price');
        if (productPrice) productPrice.textContent = priceLabel;
        if (stickyPrice) stickyPrice.textContent = priceLabel;
      }

      function firstVariantForColor(color) {
        var fallback = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].color !== color) continue;
          if (!fallback) fallback = variants[i];
          if (variants[i].available) return variants[i];
        }
        return fallback;
      }

      function updateGalleryNav() {
        var gallery = document.getElementById('detail-gallery');
        if (!gallery || !gallery.parentElement) return;
        var visibleFrames = Array.prototype.filter.call(gallery.querySelectorAll('.gallery-frame'), function (frame) {
          return !frame.hidden && frame.style.display !== 'none';
        });
        var nav = gallery.parentElement.querySelector('.mobile-gallery-nav');
        if (!nav) {
          nav = document.createElement('div');
          nav.className = 'mobile-gallery-nav';
          nav.setAttribute('aria-hidden', 'true');
          var previous = document.createElement('span');
          previous.className = 'mobile-gallery-nav-arrow';
          previous.textContent = '←';
          var dots = document.createElement('span');
          dots.className = 'mobile-gallery-dots';
          var next = document.createElement('span');
          next.className = 'mobile-gallery-nav-arrow';
          next.textContent = '→';
          nav.appendChild(previous);
          nav.appendChild(dots);
          nav.appendChild(next);
          gallery.parentElement.appendChild(nav);
        }
        nav.hidden = visibleFrames.length < 2;
        var dotsWrap = nav.querySelector('.mobile-gallery-dots');
        while (dotsWrap.firstChild) dotsWrap.removeChild(dotsWrap.firstChild);
        var current = gallery.clientWidth ? Math.round(gallery.scrollLeft / gallery.clientWidth) : 0;
        current = Math.max(0, Math.min(current, visibleFrames.length - 1));
        visibleFrames.forEach(function (_, index) {
          var dot = document.createElement('span');
          dot.className = 'mobile-gallery-dot' + (index === current ? ' is-active' : '');
          dotsWrap.appendChild(dot);
        });
      }

      function updateImages(color) {
        var frames = document.querySelectorAll('#detail-gallery .gallery-frame');
        var firstVisible = null;
        var visibleFrameIndex = 0;
        for (var frameIndex = 0; frameIndex < frames.length; frameIndex++) {
          var frame = frames[frameIndex];
          var showFrame = frame.getAttribute('data-color') === color;
          frame.hidden = !showFrame;
          frame.style.display = showFrame ? '' : 'none';
          if (showFrame) {
            var image = frame.querySelector('img');
            if (image) {
              image.loading = 'eager';
              image.decoding = 'async';
              image.fetchPriority = visibleFrameIndex < 2 ? 'high' : 'auto';
            }
            visibleFrameIndex++;
            if (!firstVisible) firstVisible = frame;
          }
        }
        var gallery = document.getElementById('detail-gallery');
        if (gallery) gallery.scrollLeft = 0;
        updateGalleryNav();
        if (!firstVisible) return;
        var sourceImage = firstVisible.querySelector('img');
        var mobileHero = document.querySelector('.mobile-product-hero');
        var mobileImage = mobileHero ? mobileHero.querySelector('img') : null;
        if (sourceImage && mobileImage) {
          mobileImage.src = sourceImage.currentSrc || sourceImage.src;
          mobileImage.alt = sourceImage.alt;
          mobileHero.classList.toggle('mobile-product-hero-model', firstVisible.classList.contains('gallery-model'));
        }
      }

      var detailGallery = document.getElementById('detail-gallery');
      if (detailGallery) {
        detailGallery.addEventListener('scroll', function () {
          window.requestAnimationFrame(updateGalleryNav);
        }, { passive: true });
        window.addEventListener('resize', updateGalleryNav);
      }

      function syncSelectedVariantInput(value) {
        var currentInput = document.getElementById('selected-variant-id');
        if (!currentInput) return;
        var nextValue = value ? String(value) : '';
        currentInput.value = nextValue;
        if (nextValue) currentInput.setAttribute('value', nextValue);
        else currentInput.removeAttribute('value');
        currentInput.dispatchEvent(new Event('change', { bubbles: true }));
        input = currentInput;
      }

      function updateAddButton() {
        var ready = false;
        var variant = null;
        if (!selectedColor) {
          addBtn.disabled = true;
          addBtn.textContent = 'SELECT A COLOR';
        } else if (!selectedSize) {
          addBtn.disabled = true;
          addBtn.textContent = 'SELECT A SIZE';
        } else {
          variant = findVariant(selectedColor, selectedSize);
          if (!variant || !variant.available) {
            addBtn.disabled = true;
            addBtn.textContent = 'SOLD OUT';
          } else {
            addBtn.disabled = false;
            addBtn.textContent = 'ADD TO BAG';
            ready = true;
          }
        }
        syncSelectedVariantInput(ready ? variant.id : '');
        if (form) form.classList.toggle('is-ready', ready);
        if (ready) {
          window.requestAnimationFrame(function () {
            syncSelectedVariantInput(variant.id);
          });
        }
      }

      if (form && 'MutationObserver' in window) {
        var variantSyncObserver = new MutationObserver(function () {
          if (!selectedColor || !selectedSize) return;
          var selectedVariant = findVariant(selectedColor, selectedSize);
          if (!selectedVariant || !selectedVariant.available) return;
          var currentInput = document.getElementById('selected-variant-id');
          var expectedId = String(selectedVariant.id);
          if (currentInput && (currentInput.value !== expectedId || currentInput.getAttribute('value') !== expectedId)) {
            currentInput.value = expectedId;
            currentInput.setAttribute('value', expectedId);
            input = currentInput;
          }
        });
        variantSyncObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        form.addEventListener('formdata', function (event) {
          var selectedVariant = findVariant(selectedColor, selectedSize);
          if (selectedVariant && selectedVariant.available) event.formData.set('id', String(selectedVariant.id));
        });
      }

      function refreshSizeButtons() {
        var avail = selectedColor ? availableSizesFor(selectedColor) : null;
        sizeButtons.forEach(function (b) {
          var size = b.dataset.size;
          b.disabled = avail ? !avail[size] : false;
          var selected = b.dataset.size === selectedSize;
          b.classList.toggle('selected', selected);
          b.setAttribute('aria-pressed', String(selected));
        });
      }

      colorWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-color]');
        if (!btn) return;
        selectedColor = btn.dataset.color;
        colorButtons.forEach(function (b) {
          var sel = b === btn;
          b.classList.toggle('selected', sel);
          b.setAttribute('aria-pressed', String(sel));
        });
        if (colorLabel) colorLabel.textContent = selectedColor ? '- ' + selectedColor : '';
        if (selectedSize) {
          var avail = availableSizesFor(selectedColor);
          if (!avail[selectedSize]) selectedSize = null;
        }
        refreshSizeButtons();
        updateImages(selectedColor);
        updatePrice(firstVariantForColor(selectedColor));
        updateAddButton();
      });

      sizeWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-size]');
        if (!btn || btn.disabled) return;
        selectedSize = btn.dataset.size;
        refreshSizeButtons();
        updatePrice(findVariant(selectedColor, selectedSize));
        updateAddButton();
      });

      if (colorButtons.length) {
        colorButtons[0].click();
      } else {
        refreshSizeButtons();
        updateAddButton();
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var variant = findVariant(selectedColor, selectedSize);
          if (!variant || !variant.available) return;
          syncSelectedVariantInput(variant.id);
          addBtn.disabled = true;
          addToCart(variant.id)
            .then(function () {
              fetchCart();
              toast('Saved to your bag');
              var d = document.getElementById('bag-dialog');
              if (d && d.showModal) d.showModal();
            })
            .catch(function () { toast('Could not add to bag'); })
            .finally(function () { updateAddButton(); });
        });
      }
    } else {
      /* ---- Fallback: flat variant list (no separate color/size options) ---- */
      var formFallback = document.getElementById('product-form');
      var inputFallback = document.getElementById('selected-variant-id');
      var addBtnFallback = document.getElementById('add-bag');

      sizeWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-variant-id]');
        if (!btn || btn.dataset.available === 'false') return;
        $$('[data-variant-id]', sizeWrap).forEach(function (b) {
          var selected = b === btn;
          b.classList.toggle('selected', selected);
          b.setAttribute('aria-pressed', String(selected));
        });
        inputFallback.value = btn.dataset.variantId;
        addBtnFallback.disabled = false;
        addBtnFallback.textContent = 'ADD TO BAG';
      });

      if (formFallback) {
        formFallback.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!inputFallback.value) return;
          addBtnFallback.disabled = true;
          addToCart(inputFallback.value)
            .then(function () {
              fetchCart();
              toast('Saved to your bag');
              var d = document.getElementById('bag-dialog');
              if (d && d.showModal) d.showModal();
            })
            .catch(function () { toast('Could not add to bag'); })
            .finally(function () { addBtnFallback.disabled = false; });
        });
      }
    }
  }

  fetchCart();
})();

/* ---------------- Free shipping progress bar ---------------- */
(function () {
  var bar = document.getElementById('shipping-bar');
  if (!bar) return;
  var fill = document.getElementById('shipping-bar-fill');
  var message = document.getElementById('shipping-bar-message');
  var threshold = parseFloat(bar.dataset.threshold || '0') * 100;
  var progressCopy = bar.dataset.copy || '';
  var successCopy = bar.dataset.success || '';

  function update() {
    if (!threshold) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        if (fill) fill.style.width = pct + '%';
        var remaining = threshold - cart.total_price;
        var moneyStr;
        try {
          moneyStr = new Intl.NumberFormat('en-US', { style: 'currency', currency: cart.currency || 'USD' }).format(Math.max(0, remaining) / 100);
        } catch (e) {
          moneyStr = '$' + (Math.max(0, remaining) / 100).toFixed(2);
        }
        if (message) message.textContent = remaining > 0 ? progressCopy.replace('{{ amount }}', moneyStr) : successCopy;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#bag-toggle')) update();
  });
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'product-form') setTimeout(update, 400);
  });
  update();
})();

/* ---------------- Scroll-in reveal ---------------- */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
})();

/* ---------------- Sticky add-to-cart (PDP) ---------------- */
(function () {
  var bar = document.getElementById('sticky-atc');
  var anchor = document.getElementById('add-bag');
  if (!bar || !anchor) return;
  var barBtn = bar.querySelector('button');

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  if (barBtn) {
    barBtn.addEventListener('click', function () { anchor.click(); });
  }
})();



var menuToggle = document.getElementById('menu-toggle');
var siteMenu = document.getElementById('site-menu');
if (menuToggle && siteMenu) {
  menuToggle.addEventListener('click', function () {
    var isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!isOpen));
    siteMenu.classList.toggle('is-open', !isOpen);
  });
}


/* Mobile product image pinch zoom with automatic reset. */
(function () {
  var pinchState = null;

  function touchDistance(touches) {
    var x = touches[0].clientX - touches[1].clientX;
    var y = touches[0].clientY - touches[1].clientY;
    return Math.sqrt((x * x) + (y * y));
  }

  function resetPinch() {
    if (!pinchState) return;
    var current = pinchState;
    pinchState = null;
    current.image.style.transition = 'transform 180ms ease-out';
    current.image.style.transform = current.previous.transform;
    window.setTimeout(function () {
      current.image.style.transition = current.previous.transition;
      current.image.style.transformOrigin = current.previous.transformOrigin;
      current.image.style.position = current.previous.position;
      current.image.style.zIndex = current.previous.zIndex;
    }, 200);
  }

  document.addEventListener('touchstart', function (event) {
    if (!window.matchMedia('(max-width: 750px)').matches || event.touches.length !== 2) return;
    var image = event.target.closest('#detail-gallery img');
    if (!image) return;
    if (pinchState) resetPinch();

    var rect = image.getBoundingClientRect();
    var centerX = ((event.touches[0].clientX + event.touches[1].clientX) / 2) - rect.left;
    var centerY = ((event.touches[0].clientY + event.touches[1].clientY) / 2) - rect.top;
    pinchState = {
      image: image,
      distance: touchDistance(event.touches),
      previous: {
        transition: image.style.transition,
        transform: image.style.transform,
        transformOrigin: image.style.transformOrigin,
        position: image.style.position,
        zIndex: image.style.zIndex
      }
    };
    image.style.transition = 'none';
    image.style.transformOrigin = ((centerX / rect.width) * 100) + '% ' + ((centerY / rect.height) * 100) + '%';
    image.style.position = 'relative';
    image.style.zIndex = '2';
  }, { passive: false });

  document.addEventListener('touchmove', function (event) {
    if (!pinchState || event.touches.length !== 2) return;
    event.preventDefault();
    var scale = touchDistance(event.touches) / pinchState.distance;
    scale = Math.max(1, Math.min(3, scale));
    pinchState.image.style.transform = 'scale(' + scale + ')';
  }, { passive: false });

  document.addEventListener('touchend', function (event) {
    if (pinchState && event.touches.length < 2) resetPinch();
  }, { passive: true });

  document.addEventListener('touchcancel', resetPinch, { passive: true });
})();

(function () {
  function isProductImageGesture(event) {
    return window.matchMedia('(max-width: 750px)').matches && event.target && event.target.closest && event.target.closest('#detail-gallery img');
  }

  document.addEventListener('touchstart', function (event) {
    if (event.touches.length === 2 && isProductImageGesture(event)) event.preventDefault();
  }, { passive: false, capture: true });

  ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (isProductImageGesture(event)) event.preventDefault();
    }, { passive: false, capture: true });
  });
})();